export default {
      id: "monitor-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#monitor-usage",
      toString: function () {
        return this.url;
      }
    }